<template>
    <div class="container-fluid hidden-print"
         id="admin_notification"
         :style="{color: color, 'background-color': backgroundColor}"
         v-html="notificationText"></div>
</template>

<script>
    export default {
        name: "AdminNotification",
        props: {
            // authored by site admins in django admin, rendered as html the same way the
            // angular directive did with $sce.trustAsHtml
            notificationText: {type: String, default: ''},
            color: {type: String, default: '#ffffff'},
            backgroundColor: {type: String, default: '#0B3181'},
        }
    };
</script>
